// Mock data for 4DPocket 3D Mockup Service Landing Page

export const mockData = {
  // Company info
  company: {
    name: "株式会社4D Pocket",
    service: "3Dモックアップ制作サービス",
    logo: "https://customer-assets.emergentagent.com/job_f05c7815-b915-4fe7-ad36-ccb3d3befcbc/artifacts/ag852xw0_4DP_logo.svg"
  },

  // Hero section
  hero: {
    title: "撮影不要。最短1日で、\n売れる商品画像を。",
    subtitle: "3Dモックアップで、CTR・ブランド力・SEOを同時に底上げ。\n発売前からEC・SNS運用を加速します。",
    ctaText: "無料で見積もりを依頼する",
    microCopy: "最短当日返信／まずは1点からでOK",
    heroImage: "/images/image01.png"
    },

  // Problems section
  problems: {
    title: "サムネイル画像作成で、こんな悩みございませんか？",
    issues: [
      {
        title: "撮影工程が多く、納品までに時間がかかる",
        description: "スタジオ撮影では、デザイン作成から試作・撮影・修正まで複数の工程が必要。\nそのため、納品までに1〜2か月かかるケースも多く、スピード感を求めるEC運用には不向き。",
      },
      {
        title: "商品の特徴がうまく伝わらない", 
        description: "サムネイルは「商品の顔」。主要な特徴や利点が見えづらいと、クリック率や購入意欲に直結。\n通常撮影では、ステッカーやキャッチコピーの文字が光の反射やパッケージの曲面で読みにくくなることも多い。",
      },
      {
        title: "A/Bテストが難しい・コストがかかる",
        description: "通常撮影ではバリエーションを作るのに追加費用と時間が必要。\nステッカー有無などを検証したくても柔軟に対応できない。",
      }
    ]
  },

  // Solutions section
  solutions: {
    title: "3Dモックアップを利用することで、すべて解決します。",
    benefits: [
      {
        title: "スピード",
        description: "最短1日で納品。撮影より圧倒的に早い",
        icon: "FastForward"
      },
      {
        title: "表現力", 
        description: "光・角度・ステッカー表現を自在に最適化。文字も読みやすい",
        icon: "Palette"
      },
      {
        title: "コスト",
        description: "A/Bテストを約1/7の費用感で高速に回せる（※撮影比の概算）",
        icon: "TrendingDown"
      }
    ]
  },

  // Comparison section
  comparison: {
    title: "画像撮影より、3Dモックアップが選ばれる理由",
    subtitle: "コスト85％OFF、納期最短１日、手間はほぼゼロ",
    description: "だからこそ、EC用サムネイルは撮影より3Dモックアップが最適。",
    items: [
      {
        category: "価格",
        traditional: "50,000円〜数十万円（撮影費・印刷費・送料含む）",
        mockup: "約7,000円〜（レンダリング費用のみ）"
      },
      {
        category: "期間", 
        traditional: "1〜2か月（撮影準備・スタジオ手配含む）",
        mockup: "最短1日〜5日（データ入稿から即制作可能）"
      },
      {
        category: "工数",
        traditional: "撮影準備・移動・撮影・編集が必要",
        mockup: "データ共有のみでOK。修正もクリック対応"
      }
    ]
  },

  // Testimonials
  testimonials: [
    {
      content: "プロトタイプ前からEC出品・SNS運用ができた",
      author: "EC事業者A様"
    },
    {
      content: "修正がクイックで、社内意思決定が早まった", 
      author: "ブランド担当B様"
    },
    {
      content: "最高でした！対応も早く、サムネの出来栄えも満足です！",
      author: "Extra Basic様"
    }
  ],

  // Case study
  caseStudy: {
    title: "制作事例紹介：「Chew Crew」",
    budget: "60,000円",
    points: "3点",
    period: "10日",
    background: "Amazonでゴミ袋ブランド「KLEAN」を展開するExtra Basic様より依頼。ペット用ドライシャンプーブランド「Chew Crew」を新規立ち上げるにあたり、プロトタイプ完成前からEC用サムネイルやInstagram素材を作成するため、3Dモックアップを採用。",
    results: [
      "プロトタイプ完成前からInstagram運用を開始でき、発売前にブランド宣伝が可能に。",
      "3Dデータも納品したため、今後の再レンダリングや別アングルの活用も容易。"
    ],
    testimonial: "最高でした！対応も早く、サムネの出来栄えも満足です！プロトタイプが到着する前からInstagram運用を始められ、発売前からブランド宣伝ができたのが本当に良かったです。",
    // 🔽 ここを変更
    images: [
      "/images/image02.png",   // ← 1枚目（ボトル2本＋キャップ）
      "/images/image04.png"    // ← 2枚目（外箱パッケージ）
    ]
  },

// Process steps
process: {
  title: "ご利用の流れ（3Dモックアップなら数日で完了）",
  steps: [
    {
      title: "デザイン共有",
      description: "展開図データや参考画像をご準備ください。寸法・素材感・印刷デザインを元に、3D化を開始します。",
      thumb: "/images/designshare.png"      // 画像が無ければこの行は削除OK
    },
    {
      title: "モデリング",
      description: "デザインデータから3Dモデルを制作。形状やラベルの配置、質感・反射・光の当たり方まで調整。",
      thumb: "/images/modeling.png"
    },
    {
      title: "サムネイル完成",
      description: "EC用の高解像度サムネイルとしてレンダリング。撮影なしで、発売前からEC・SNS運用が可能です。",
      thumb: "/images/thumbnail.png"
    }
  ]
},

  // FAQ
  faq: [
    {
      question: "プロトタイプ無しでも依頼できる？",
      answer: "はい、展開図データがあれば可能です。"
    },
    {
      question: "どのプラットフォームに対応？", 
      answer: "Amazon／楽天／Shopify／自社ECすべて対応可能です。"
    },
    {
      question: "修正は何回まで可能ですか？",
      answer: "基本プランでは2回まで無料修正が含まれます。追加修正も柔軟に対応いたします。"
    },
    {
      question: "納期はどのくらいですか？",
      answer: "最短1日で納品可能です。ただし、複雑なデザインの場合は5〜10営業日かかる場合があります。詳細はお見積り時にご案内いたします。"
    }
  ],

  // Gallery images
  gallery: [
    "https://images.unsplash.com/photo-1667266543254-505cf5b16ec4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHwzRCUyMHByb2R1Y3QlMjBtb2NrdXB8ZW58MHx8fHwxNzU5Mzk3MDgwfDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1626253934161-08cfea22e968?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxwYWNrYWdpbmclMjBkZXNpZ258ZW58MHx8fHwxNzU5Mzk3MDg2fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1684882726821-2999db517441",
    "https://images.unsplash.com/photo-1725328493423-3771b60d02c2"
  ]
};